export enum ButtonType {
  PRIMARY = 'primary',
  PRIMARY_SLIM = 'primary-slim',
  PRIMARY_LARGE = 'primary-large',
  PRIMARY_MOBILE = 'primary-full-width-mobile',
  SECONDARY = 'secondary',
  SECONDARY_SLIM = 'secondary-slim',
  SECONDARY_LARGE = 'secondary-large',
  SECONDARY_GHOST = 'secondary-ghost',
  CALLOUT = 'callout',
  CALLOUT_SLIM = 'callout-slim',
  CALLOUT_LARGE = 'callout-large',
  STEP_2 = 'btn-step2',
}
